// extracted by mini-css-extract-plugin
export var label = "_9a-1";
export var reminder = "_9a-0";